import React from 'react';

import { GOLD, MajorSigil, SuitGlyph } from '../art/glyphs';
import { SpreadId } from '../spreads';

/** The major arcana sigil that stands for each spread (Lovers, Chariot, Wheel, Justice). */
const SIGIL: Partial<Record<SpreadId, number>> = {
    love: 6,
    work: 7,
    path: 10,
    yesno: 11,
};

export const SigilIcon: React.FC<{ spread: SpreadId; size?: number }> = ({
    spread,
    size = 56,
}) => (
    <svg
        viewBox="-56 -56 112 112"
        width={size}
        height={size}
        aria-hidden="true"
        fill="none"
        stroke={GOLD}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        {SIGIL[spread] !== undefined ? (
            <MajorSigil rank={SIGIL[spread]!} />
        ) : (
            <g transform="scale(1.8)">
                <SuitGlyph suit="cups" />
            </g>
        )}
    </svg>
);
